import React from 'react'
import { createStackNavigator } from '@react-navigation/stack';
import Dashboard from "../../components/sideMenu/Dashboard";

const Stack = createStackNavigator()

const TabOneStack = () => {
  return (
    <Stack.Navigator screenOptions={{
      headerShown: false,
    }}>
      <Stack.Screen name="Dashboard" component={Dashboard} options={{ title: 'golf-eq-app' }} />
    </Stack.Navigator>
  )
}

export default TabOneStack;